(function () {
  'use strict';

  var CACHE_TTL = 5 * 60 * 1000;
  var CACHE_PREFIX = 'bundly-prices:';
  var pendingFetches = {};

  function getCards() {
    return Array.prototype.slice.call(
      document.querySelectorAll('[data-bundly-price-card]:not([data-bundly-prices-loaded])')
    );
  }

  function getProductUrl(card) {
    return card.getAttribute('data-product-url') || '';
  }

  function getProductJsUrl(productUrl) {
    var path = productUrl.split('?')[0].replace(/\/$/, '');
    return path + '.js';
  }

  function formatCents(cents) {
    if (typeof theme !== 'undefined' && theme.Currency && theme.moneyFormat) {
      return theme.Currency.formatMoney(cents, theme.moneyFormat);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function parseMoneyValue(text) {
    if (!text) return null;
    var normalized = String(text)
      .replace(/\s/g, '')
      .replace(/[^\d,.-]/g, '');
    if (!normalized) return null;

    var lastComma = normalized.lastIndexOf(',');
    var lastDot = normalized.lastIndexOf('.');

    if (lastComma > -1 && lastDot > -1) {
      if (lastComma > lastDot) {
        normalized = normalized.replace(/\./g, '').replace(',', '.');
      } else {
        normalized = normalized.replace(/,/g, '');
      }
    } else if (lastComma > -1) {
      var afterComma = normalized.length - lastComma - 1;
      normalized = afterComma === 2
        ? normalized.replace(',', '.')
        : normalized.replace(/,/g, '');
    }

    var amount = parseFloat(normalized);
    return isNaN(amount) ? null : amount;
  }

  function isValidPriceData(data) {
    if (!data || !data.sale) return false;

    var saleAmount = parseMoneyValue(data.sale);
    if (saleAmount == null || saleAmount <= 0) return false;

    if (data.original) {
      var originalAmount = parseMoneyValue(data.original);
      if (originalAmount == null || originalAmount <= 0) return false;
    }

    return true;
  }

  function shouldShowCompare(original, sale) {
    var o = parseMoneyValue(original);
    var s = parseMoneyValue(sale);
    if (o == null || s == null) return false;
    return o > s;
  }

  function purgeInvalidCache() {
    try {
      for (var i = sessionStorage.length - 1; i >= 0; i--) {
        var key = sessionStorage.key(i);
        if (!key || key.indexOf(CACHE_PREFIX) !== 0) continue;

        var raw = sessionStorage.getItem(key);
        if (!raw) {
          sessionStorage.removeItem(key);
          continue;
        }

        try {
          var entry = JSON.parse(raw);
          if (!entry || !entry.data || !isValidPriceData(entry.data)) {
            sessionStorage.removeItem(key);
          }
        } catch (e) {
          sessionStorage.removeItem(key);
        }
      }
    } catch (e) {
      /* ignore */
    }
  }

  function readCache(url) {
    try {
      var raw = sessionStorage.getItem(CACHE_PREFIX + url);
      if (!raw) return null;
      var entry = JSON.parse(raw);
      if (!entry || Date.now() - entry.ts > CACHE_TTL) {
        sessionStorage.removeItem(CACHE_PREFIX + url);
        return null;
      }
      if (!isValidPriceData(entry.data)) {
        sessionStorage.removeItem(CACHE_PREFIX + url);
        return null;
      }
      return entry.data;
    } catch (e) {
      return null;
    }
  }

  function writeCache(url, data) {
    if (!isValidPriceData(data)) return;
    try {
      sessionStorage.setItem(
        CACHE_PREFIX + url,
        JSON.stringify({ ts: Date.now(), data: data })
      );
    } catch (e) {
      /* ignore quota errors */
    }
  }

  function dataFromProductJson(json) {
    if (!json || !json.price || json.price <= 0) return null;

    var data = {
      sale: formatCents(json.price),
      original: ''
    };

    if (json.compare_at_price && json.compare_at_price > json.price) {
      data.original = formatCents(json.compare_at_price);
    }

    return isValidPriceData(data) ? data : null;
  }

  function getEmbeddedPrices(card) {
    var priceCents = parseInt(card.getAttribute('data-bundly-price-cents'), 10);
    var compareCents = parseInt(card.getAttribute('data-bundly-compare-cents'), 10);

    if (!priceCents || priceCents <= 0) return null;

    var data = {
      sale: formatCents(priceCents),
      original: ''
    };

    if (compareCents && compareCents > priceCents) {
      data.original = formatCents(compareCents);
    }

    return isValidPriceData(data) ? data : null;
  }

  function extractPricesFromHtml(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var originalEl =
      doc.querySelector('.bundly__bundle_original_price') ||
      doc.querySelector('[class*="bundle_original_price"]');
    var saleEl =
      doc.querySelector('.bundly__bundle_new_price') ||
      doc.querySelector('[class*="bundle_new_price"]');

    var original = originalEl ? originalEl.textContent.trim() : '';
    var sale = saleEl ? saleEl.textContent.trim() : '';

    if (!original && !sale) return null;

    var data = { original: original, sale: sale };
    return isValidPriceData(data) ? data : null;
  }

  function findPriceEl(card) {
    return card.querySelector('.price');
  }

  function cardShowsZero(card) {
    var priceEl = findPriceEl(card);
    if (!priceEl) return true;
    var amount = parseMoneyValue(priceEl.textContent);
    return amount == null || amount <= 0;
  }

  function markCardReady(card) {
    var priceEl = findPriceEl(card);
    if (priceEl) priceEl.classList.remove('price--bundly-pending');
    card.setAttribute('data-bundly-prices-loaded', 'true');
  }

  function renderPrice(card, data) {
    var priceEl = findPriceEl(card);
    if (!priceEl || !data || !isValidPriceData(data)) return;

    var original = data.original || '';
    var sale = data.sale || '';
    var html = '';

    if (sale && shouldShowCompare(original, sale)) {
      html +=
        '<span class="hidden_txt">Regular price</span>' +
        '<s class="pr_price">' + original + '</s>' +
        '<span class="pr_price sale">' + sale + '</span>';
    } else if (sale) {
      html =
        '<span class="hidden_txt">Regular price</span>' +
        '<span class="pr_price">' + sale + '</span>';
    } else {
      return;
    }

    priceEl.innerHTML = html;
    priceEl.classList.remove('price--bundly-pending');
    card.setAttribute('data-bundly-prices-loaded', 'true');
  }

  function fetchProductJson(url) {
    return fetch(getProductJsUrl(url), { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('product.js fetch failed');
        return res.json();
      })
      .then(function (json) {
        return dataFromProductJson(json);
      })
      .catch(function () {
        return null;
      });
  }

  function fetchBundlyHtml(url) {
    return fetch(url, { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('pdp fetch failed');
        return res.text();
      })
      .then(function (html) {
        return extractPricesFromHtml(html);
      })
      .catch(function () {
        return null;
      });
  }

  function fetchPrices(url) {
    if (pendingFetches[url]) return pendingFetches[url];

    var cached = readCache(url);
    if (cached) return Promise.resolve(cached);

    pendingFetches[url] = fetchProductJson(url)
      .then(function (data) {
        if (data) {
          writeCache(url, data);
          return data;
        }
        return fetchBundlyHtml(url);
      })
      .then(function (data) {
        if (data && isValidPriceData(data)) {
          writeCache(url, data);
        }
        return data;
      })
      .then(function (data) {
        delete pendingFetches[url];
        return data;
      });

    return pendingFetches[url];
  }

  function updateCard(card) {
    var url = getProductUrl(card);
    if (!url) {
      markCardReady(card);
      return Promise.resolve();
    }

    var embedded = getEmbeddedPrices(card);

    if (embedded && shouldShowCompare(embedded.original, embedded.sale)) {
      renderPrice(card, embedded);
      return Promise.resolve();
    }

    return fetchPrices(url).then(function (data) {
      if (data && isValidPriceData(data) && shouldShowCompare(data.original, data.sale)) {
        renderPrice(card, data);
        return;
      }

      if (cardShowsZero(card)) {
        if (data && isValidPriceData(data)) {
          renderPrice(card, data);
          return;
        }
        if (embedded && isValidPriceData(embedded)) {
          renderPrice(card, embedded);
          return;
        }
      }

      markCardReady(card);
    });
  }

  function updateAll() {
    var cards = getCards();
    if (!cards.length) return;

    var promises = cards.map(function (card) {
      return updateCard(card);
    });

    return Promise.all(promises);
  }

  function startObserver() {
    if (typeof MutationObserver === 'undefined') return;

    var observer = new MutationObserver(function () {
      updateAll();
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    purgeInvalidCache();
    updateAll();
    startObserver();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
